var _SizeSemantics;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Inset } from '@doordash/design-language';
export var Sizes = {
  Small: Inset.Sizes.XxSmall,
  Medium: Inset.Sizes.Small,
  Large: Inset.Sizes.Large
};
export var SizeSemantics = (_SizeSemantics = {}, _defineProperty(_SizeSemantics, Sizes.Small, 'FieldSmall'), _defineProperty(_SizeSemantics, Sizes.Medium, 'FieldMedium'), _defineProperty(_SizeSemantics, Sizes.Large, 'FieldLarge'), _SizeSemantics);